import { BASE_URL, WEBSITE_BASE_URL } from '../../../Constant';

export const API_WEBSITE_LOGOUT_URL: string = `${WEBSITE_BASE_URL}/api/logout`;
export const API_LOGOUT_URL: string = `${BASE_URL}/logout`;
